import { MissionDataSet } from '../DataSet/Mission';
import { IDataHandler } from '../IDataHandler';
import { MissionTrackingEventName } from '../TrackingEvent';

export const MissionEventDataMap: {
    [key in MissionTrackingEventName]: (keyof MissionDataSet)[];
} = {
    [MissionTrackingEventName.missionCompleted]: [
        'missionID',
        'missionName',
        'mLevel',
        'mLevelType',
        'mGoalAmount',
        'mRetryNum',
        'mIsSuccessfulRetry',
        'mLevelMoves',
        'mHighestPlayStreak',
        'mChangerUsed',
        'mRemoveOneUsed',
        'mMassRemoveUsed',
        'mJokerUsed',
        'mUndoUsed',
        'mExtraCardsBought',
        'mExtraCardsWon',
        'mCoinsSpent',
        'mNoActionCardStreak',
        'mNoPossibleActionStreak',
        'mGoalsCompletedPercentage',
        'mFriendHelped',
        'mFriendWhoHelped',
        'mCardsLeft',
        'mStars',
        'mLossAversionCoinsSpent',
        'mScore',
        'mScoreBeforeEndSequence',
        'mCoinsBoughtWithRealMoney',
        'mBoostersBoughtWithRealMoney',
        'mLevelTypeContext',
    ],
    [MissionTrackingEventName.missionStarted]: [
        'missionID',
        'missionName',
        'mLevel',
        'mLevelType',
        'mGoalAmount',
        'mRetryNum',
        'mLevelMoves',
        'mStars',
        'mLevelTypeContext',
    ],
    [MissionTrackingEventName.missionFailed]: [
        'missionID',
        'missionName',
        'mLevel',
        'mLevelType',
        'mGoalAmount',
        'mRetryNum',
        'mLevelMoves',
        'mHighestPlayStreak',
        'mChangerUsed',
        'mRemoveOneUsed',
        'mMassRemoveUsed',
        'mJokerUsed',
        'mUndoUsed',
        'mExtraCardsBought',
        'mExtraCardsWon',
        'mCoinsSpent',
        'mNoActionCardStreak',
        'mNoPossibleActionStreak',
        'mGoalsCompletedPercentage',
        'mFriendHelped',
        'mFriendWhoHelped',
        'mCardsLeft',
        'mStars',
        'mLossAversionCoinsSpent',
        'mScore',
        'mCoinsBoughtWithRealMoney',
        'mBoostersBoughtWithRealMoney',
        'mLevelTypeContext',
    ],
};

export class MissionDataHandler implements IDataHandler<MissionDataSet> {
    public data: MissionDataSet = new MissionDataSet();

    public getEventData(eventName: MissionTrackingEventName): MissionDataSet {
        const data = MissionEventDataMap[eventName].reduce(
            (acc, key) => {
                acc[key] = this.data[key];
                return acc;
            },
            {} as MissionDataSet
        );

        // Reset mission data.
        if (
            eventName === MissionTrackingEventName.missionCompleted ||
            eventName === MissionTrackingEventName.missionFailed
        ) {
            this.data = new MissionDataSet();
        }

        if (eventName === MissionTrackingEventName.missionStarted) {
            this.data.mCoinsBoughtWithRealMoney = 0;
            this.data.mBoostersBoughtWithRealMoney = 0;
        }

        // Special handling for `mGoalsCompletedPercentage` due to complexity
        // in performing the calculation in the state.
        if (this.data.mGoalsCompletedPercentage && this.data.mGoalAmount) {
            this.data.mGoalsCompletedPercentage =
                this.data.mGoalsCompletedPercentage / this.data.mGoalAmount;
        }

        return data;
    }
}
